import { useCallback, useRef } from 'react';
import { useGetMe } from 'src/api/user_api';
import { ROLES } from 'src/layouts/guard/role_guard';
import { playFailSound, playSuccessSound, speakText } from 'src/utils/sound';

export const SCAN_SOUND_ROLES = [ROLES.LOCATION_MANAGER, ROLES.WORKER];

export function useScanSound() {
  const { role } = useGetMe();
  const enabledRef = useRef(false);
  enabledRef.current = SCAN_SOUND_ROLES.includes(role);

  const playSuccess = useCallback(() => {
    if (enabledRef.current) playSuccessSound();
  }, []);

  const playFail = useCallback(() => {
    if (enabledRef.current) playFailSound();
  }, []);

  const speak = useCallback((text) => {
    if (enabledRef.current) speakText(text);
  }, []);

  return { playSuccess, playFail, speak };
}
